var React = require('react');

function Leading (props) {
    return React.createElement("svg",props,[React.createElement("clipPath",{"id":"a","key":0},React.createElement("path",{"id":"SVGID","d":"M1.26 2.5h25.47v15H1.26z"})),React.createElement("g",{"clipPath":"url(#a)","fill":"none","stroke":"#333","strokeMiterlimit":"10","strokeWidth":".86","opacity":".4","key":1},React.createElement("path",{"d":"M.16 11.31l26.58-7.67M26.74 6.86L.16 12.61M26.74 10.07L.16 13.91M26.74 13.29L.16 15.2M26.74 16.5H.16"}))]);
}

Leading.defaultProps = {"id":"Layer_1","viewBox":"0 0 28 20"};

module.exports = Leading;

Leading.default = Leading;
